import React from "react"
import { GiftOutlined, EnvironmentOutlined } from "@ant-design/icons"
import Tackle from "../../../../assets/icons/tackle.svg"
import Hopefully from "../../../../assets/icons/Hopefully.svg"
import FishingPoles from "../../../../assets/icons/fishing_pole.svg"
import Sunscreen from "../../../../assets/icons/Sunscreen.svg"
import Sunglasses from "../../../../assets/icons/Sunglasses.svg"
import Ice from "../../../../assets/icons/Vector.svg"
import Cooler from "../../../../assets/icons/Cooler.svg"
import BottledWater from "../../../../assets/icons/BottledWater.svg"
import Alcohol from "../../../../assets/icons/Alcohol.svg"
import Intermediate from "../../../../assets/icons/Intermediate.svg"

/**
 * Maps item names to their corresponding icon and label
 */
export const ITEM_ICON_MAP = {
  "Fishing Lure": { label: "Fishing lure", icon: <GiftOutlined /> },
  Tackle: { label: "Tackle", icon: <img src={Tackle} alt="tackle" /> },
  "Insect Repellent": { label: "Insect repellent", icon: <GiftOutlined /> },
  "Waterproof Bag": { label: "Waterproof bag", icon: <GiftOutlined /> },
  "Hopefully Some Luck!": { label: "Hopefully some luck:)", icon: <img src={Hopefully} alt="some_luck" /> },
  "Life Jackets": { label: "Life jackets", icon: <GiftOutlined /> },
  "First Aid Kit": { label: "First aid kit", icon: <GiftOutlined /> },
  "Snorkel Mask": { label: "Snorkel mask", icon: <GiftOutlined /> },
  "Fishing Poles": { label: "Fishing poles", icon: <img src={FishingPoles} alt="fishing_poles" /> },
  Sinkers: { label: "Sinkers", icon: <GiftOutlined /> },
  Hooks: { label: "Hooks", icon: <GiftOutlined /> },
  "Water Shoes": { label: "Water shoes", icon: <GiftOutlined /> },
  Towels: { label: "Towels", icon: <GiftOutlined /> },
  Swimwear: { label: "Swimwear", icon: <GiftOutlined /> },
  Sunscreen: { label: "Sunscreen", icon: <img src={Sunscreen} alt="sunscreen" /> },
  Sunglasses: { label: "Sunglasses", icon: <img src={Sunglasses} alt="sunglasses" /> },
  Ice: { label: "Ice", icon: <img src={Ice} alt="ice" /> },
  Cooler: { label: "Cooler", icon: <img src={Cooler} alt="cooler" /> },
  "Bottled Water": { label: "Bottled water", icon: <img src={BottledWater} alt="bottled_water" /> },
  Snacks: { label: "Snacks", icon: <GiftOutlined /> },
  Lunch: { label: "Lunch", icon: <GiftOutlined /> }
}

/**
 * Maps skill levels to their corresponding icon and label
 */
export const SKILL_LEVEL_MAP = {
  beginner: { label: "Beginner", icon: <img src={Intermediate} alt="beginner" /> },
  intermediate: { label: "Intermediate", icon: <img src={Intermediate} alt="intermediate" /> },
  advanced: { label: "Advanced", icon: <GiftOutlined /> },
  professional: { label: "Professional", icon: <GiftOutlined /> }
}

/**
 * Maps other items to their corresponding icon and label
 */
export const OTHER_ITEMS_MAP = {
  "Wheelchair accessible": { label: "Wheelchair accessible", icon: <GiftOutlined /> },
  "Child friendly": { label: "Child friendly", icon: <EnvironmentOutlined /> },
  "Alcohol allowed": { label: "Alcohol allowed", icon: <img src={Alcohol} alt="alcohol" /> }
}

/**
 * Maps not allowed items to their corresponding icon and label
 */
export const NOT_ALLOWED_MAP = {
  alcohol: { label: "Alcohol is not allowed", icon: <img src={Alcohol} alt="alcohol" /> }
}

/**
 * Get item details with fallback to default icon
 */
export const getItemDetails = (item) => {
  return ITEM_ICON_MAP[item] || { label: item, icon: <GiftOutlined /> }
}

/**
 * Get skill level details with fallback to default icon
 */
export const getSkillLevelDetails = (item) => {
  return SKILL_LEVEL_MAP[item] || { label: item, icon: <GiftOutlined /> }
}

/**
 * Get other item details
 */
export const getOtherDetails = (item) => {
  return OTHER_ITEMS_MAP[item]
}

/**
 * Get not allowed item details
 */
export const getNotAllowedDetails = (item) => {
  return NOT_ALLOWED_MAP[item]
}
